import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';

import { nav } from '@/_nav';
import TheFooter from '@/components/Includes/Footer/Footer';
import TheHeader from '@/components/Includes/Header/Header';
import Loader from '@/components/Includes/Loader/Loader.vue';
import DefaultAside from '@/containers/DefaultAside.vue';
import IProfile from '@/interfaces/IProfile';
import { tokenToClipboard } from '@/libs/auth/isAuth';
import {
    Aside as AppAside, AsideToggler, Breadcrumb, Sidebar as AppSidebar, SidebarFooter, SidebarForm,
    SidebarHeader, SidebarMinimizer, SidebarNav, SidebarToggler
} from '@coreui/vue';

tokenToClipboard()

@Component({
    name: 'Main',
    components: {
        AsideToggler,
        AppSidebar,
        AppAside,
        Breadcrumb,

        TheHeader,
        TheFooter,
        Loader,

        DefaultAside,
        SidebarForm,
        SidebarFooter,
        SidebarToggler,
        SidebarHeader,
        SidebarNav,
        SidebarMinimizer
    }
})
export default class Main extends Vue {
    @Action private currentUser!: () => Promise<void>;
    @Getter private profile!: IProfile;

    private isReady = false;

    get currentUserRoles () {
        return this.profile ? this.profile.allRoles : [];
    }

    get nav () {
        if (this.currentUserRoles){
            if (this.currentUserRoles.length) {
                return nav(this.currentUserRoles);
            }
            else {
                return [];
            }
        }
    }

    get name() {
        return this.$route.name;
    }

    get list() {
        return this.$route.matched.filter(
            route => route.name || route.meta.label
        );
    }

    private async created() {
        try {
            await this.currentUser();
        } catch(error) {
            console.error(error);
        }
        
        this.isReady = true;
    }
}
